import { useEffect, useState } from 'react'
import { KlearDate } from '@klear/date'
import { useRecoveryMutations } from '@klear/ui/hooks/use-collections'
import { Button } from '@klear/ui/components/button'
import { DatePicker } from '@klear/ui/components/date-picker'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@klear/ui/components/dialog'

type Props = {
  offerId: number
  currentDate: KlearDate | null
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function RescheduleRecoveryDialog({ offerId, currentDate, open, onOpenChange }: Props) {
  const { rescheduleRecovery, isRescheduling } = useRecoveryMutations()
  const [date, setDate] = useState<KlearDate | undefined>(currentDate ?? undefined)

  useEffect(() => {
    if (open) setDate(currentDate ?? undefined)
  }, [open, currentDate])

  const handleConfirm = async () => {
    if (date == null) return
    await rescheduleRecovery({ offerId, effectiveDate: date.toJSON() })
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Reschedule recovery</DialogTitle>
          <DialogDescription>Choose a new date for the advance recovery to be collected.</DialogDescription>
        </DialogHeader>
        <div className="py-2">
          <DatePicker value={date} onChange={setDate} disabled={isRescheduling} />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isRescheduling}>
            Cancel
          </Button>
          <Button onClick={() => void handleConfirm()} disabled={date == null || isRescheduling}>
            {isRescheduling ? 'Rescheduling…' : 'Reschedule'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
